import React, { useContext } from 'react';
import { ReactComponent as EmptyFormIllustration } from 'pages/Forms/assets/form-empty-state.svg';
import { Button, Text, Spacer, VStack } from '@televet/kibble-ui';
import { FormsContext } from '../context/FormsContext';
import { useTracking } from 'shared/providers/TrackingProvider';
import { FormsEvents } from 'shared/providers/TrackingProvider/EventNames';

const EmptyForm = (): JSX.Element => {
  const { dispatch } = useContext(FormsContext);
  const { trackEvent } = useTracking();

  const showTemplateSelector = (): void => {
    dispatch({
      type: 'TOGGLE_TEMPLATE_SELECTOR',
      payload: { isTemplateSelectorShown: true },
    });
    trackEvent(FormsEvents.AddNewForm);
  };

  return (
    <VStack spacing={2}>
      <EmptyFormIllustration />
      <Spacer />
      <Text variant="subtle">No form selected.</Text>
      <Text variant="subtle">Pick a form to view from the left, or ...</Text>
      <Spacer />
      <Button
        onClick={showTemplateSelector}
        iconName="plus"
        data-mixpanel-name="Add new form"
        data-testid="add-form-button"
      >
        Add New Form
      </Button>
    </VStack>
  );
};

export default EmptyForm;
